var map = {
	"./big/id0-always_be_ready.jpg": 37,
	"./big/id1-virginia.jpg": 38,
	"./big/id10-museu_coa-full.jpg": 39,
	"./big/id10-museu_coa.jpg": 40,
	"./big/id11-ritas.jpg": 41,
	"./big/id12-right_call-full.jpg": 42,
	"./big/id12-right_call.jpg": 43,
	"./big/id2-worlds_paths.jpg": 44,
	"./big/id3-wild_routine.jpg": 45,
	"./big/id3-wild_routine_v04.jpg": 46,
	"./big/id4-carlos_sa-full.jpg": 47,
	"./big/id4-carlos_sa.jpg": 48,
	"./big/id5-casa_correia_de_sa.jpg": 49,
	"./big/id6-casa_moreira.jpg": 50,
	"./big/id6-casa_moreira_v02.jpg": 51,
	"./big/id7-breiner310-full.jpg": 52,
	"./big/id7-breiner310.jpg": 53,
	"./big/id8-casa_joao-full.jpg": 54,
	"./big/id8-casa_joao.jpg": 55,
	"./big/id9-lido_azzurro.jpg": 56,
	"./mobile/id0-always_be_ready.jpg": 57,
	"./mobile/id1-virginia.jpg": 58,
	"./mobile/id10-museu_coa.jpg": 59,
	"./mobile/id11-ritas.jpg": 60,
	"./mobile/id12-right_call.jpg": 61,
	"./mobile/id2-worlds_paths.jpg": 62,
	"./mobile/id3-wild_routine.jpg": 63,
	"./mobile/id4-carlos_sa.jpg": 64,
	"./mobile/id5-casa_correia_de_sa.jpg": 65,
	"./mobile/id6-casa_moreira.jpg": 66,
	"./mobile/id6-casa_moreira_v02.jpg": 67,
	"./mobile/id7-breiner310.jpg": 68,
	"./mobile/id8-casa_joao.jpg": 69,
	"./mobile/id9-lido_azzurro.jpg": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;